import {
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
 
  ROLE_MANAGEMENT_LIST
} from "../type";

const initialState = {
  roleList:[],
  VisitorIndex: null,
  loader: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_UNAUTHENTICATED:
      return initialState;
    case ROLE_MANAGEMENT_LIST:
      return {
        ...state,
        roleList: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
